<template>
	<PageLoading :is-loading="isLoading"></PageLoading>
	<SideComponent @scrollto="scroll"></SideComponent>
	<div class="container" ref="viewBox">		
		<div class="header-container">
			<HeaderVR />
			<!-- <div class="bigimg-container" v-if="banner.length>0">
				<Swiper :list="banner"/>
			</div> -->
		</div>
		<div id="content" class="content" ref="content">
			 <h1>{{live_title}}</h1>
			<div class="video-wrapper">
				<video ref="videoPlayer" class="video-js vjs-big-play-centered" 
			        :controls="showControls" 
					style="width:100%;height:100%;object-fit:contain;"
					preload="metadata"
					:muted="isMuted"
					:autoplay="shouldAutoPlay"
					:poster="live_poster"
			    ></video>
				<i class="iconfont icon-huatong1 iconstyle" @click.stop="openVoice()" v-show="isMuted"></i>
				<i class="iconfont icon-huatong iconstyle" @click.stop="closeVoice()" v-show="!isMuted"></i>
			</div>
			 
   			 <!-- <video id="my-video"
	            class="video-js vjs-default-skin"
	            controls
	            preload="auto"
	        >
	            <source src="" type="application/x-mpegURL" />
	        </video> -->
		</div>
		<!-- <div style="display:flex;justify-content:center;align-items: center;width:100%;padding:20px 0;">
			<el-button type="danger" plain @click="startConversion">开始</el-button>
   			<el-button type="success" plain @click="stopConversion">停止</el-button>
		</div> -->
		<Footer/>

	</div>
	
</template>

<script>
	import rtmp from './rtmp_controller';
	export default rtmp;
</script>

<style src="@/assets/css/rtmp.css" scoped></style>
<!-- 这段全局css代码在related_news_detail.vue,subject_detail.vue,tail_detail.vue都有，而且相同。 -->


